import { render } from "./PopupItem.vue?vue&type=template&id=2b11ae78&ts=true"
import script from "./PopupItem.vue?vue&type=script&lang=ts"
export * from "./PopupItem.vue?vue&type=script&lang=ts"

import "./PopupItem.vue?vue&type=style&index=0&id=2b11ae78&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__